import { render, staticRenderFns } from "./NoImageAvailable.vue?vue&type=template&id=5a610e02"
import script from "./NoImageAvailable.vue?vue&type=script&lang=js"
export * from "./NoImageAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports